var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "accounting-doc-grid" },
    [
      _c("div", { staticClass: "grid-icon-btn" }, [
        _c("i", {
          staticClass: "el-icon-circle-plus",
          on: { click: _vm.addItem }
        }),
        _c("i", {
          staticClass: "el-icon-remove",
          on: { click: _vm.removeItem }
        })
      ]),
      _c("cargo-ag-grid", {
        staticClass: "accounting-document-grid",
        staticStyle: { width: "100%", "min-height": "325px" },
        attrs: {
          no: "grid1",
          "grid-options": _vm.gridOptions,
          "column-defs": _vm.columnDefs,
          "row-data": _vm.rowData,
          "show-side-bar": false,
          "auto-fit-content": false
        },
        on: {
          gridReady: function(params) {
            _vm.gridApi = params.api
          }
        }
      }),
      _c("cargo-ag-grid", {
        staticClass:
          " accounting-document-grid accounting-document-grid-footer",
        staticStyle: { width: "100%" },
        attrs: {
          no: "grid2",
          "grid-options": _vm.footerGridOptions,
          "column-defs": _vm.footerColumnDefs,
          "row-data": _vm.footerData,
          "show-side-bar": false,
          "auto-fit-content": false
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }